import { render, staticRenderFns } from "./LegalEntityEditor.vue?vue&type=template&id=08c129c1&scoped=true"
import script from "./LegalEntityEditor.vue?vue&type=script&lang=js"
export * from "./LegalEntityEditor.vue?vue&type=script&lang=js"
import style0 from "./LegalEntityEditor.vue?vue&type=style&index=0&id=08c129c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c129c1",
  null
  
)

export default component.exports